/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProductPoolWithdrawResultDTO interface.
 */
export function instanceOfProductPoolWithdrawResultDTO(value) {
    return true;
}
export function ProductPoolWithdrawResultDTOFromJSON(json) {
    return ProductPoolWithdrawResultDTOFromJSONTyped(json, false);
}
export function ProductPoolWithdrawResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'asins': json['asins'] == null ? undefined : json['asins'],
        'requested': json['requested'] == null ? undefined : json['requested'],
        'taken': json['taken'] == null ? undefined : json['taken'],
        'remaining': json['remaining'] == null ? undefined : json['remaining'],
        'droppedBanned': json['droppedBanned'] == null ? undefined : json['droppedBanned'],
    };
}
export function ProductPoolWithdrawResultDTOToJSON(json) {
    return ProductPoolWithdrawResultDTOToJSONTyped(json, false);
}
export function ProductPoolWithdrawResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'asins': value['asins'],
        'requested': value['requested'],
        'taken': value['taken'],
        'remaining': value['remaining'],
        'droppedBanned': value['droppedBanned'],
    };
}
